import { get } from "lodash";

export const getHomie = (state, homieId) =>
  get(state, ["chat", "homies", homieId]);
